import OlMap from "ol/Map";
import GeoJSON from "ol/format/GeoJSON";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { useEffect, useRef, useState } from "react";
import empty from "../../data/Empty.json";
import { layersStyle } from "../layers";
import * as Properties from "./properties";

export default function PublicMap({ data, skedesplanId, ...props }) {
  const layers = Properties[`id${skedesplanId}Layers`];
  const view = Properties[`id${skedesplanId}View`];

  const [map, setMap] = useState();
  const mapElement = useRef();
  const mapRef = useRef();
  const [vectorLayer, setVectorLayer] = useState();
  const dataRef = useRef();

  mapRef.current = map;

  dataRef.current = data;

  // On first render data will be null so here we set data to an empty json file. On second render
  // the data will be populated.
  data
    ? (data = new GeoJSON().readFeatures(data))
    : (data = new GeoJSON().readFeatures(empty));

  useEffect(() => {
    const vectors = new VectorLayer({
      source: new VectorSource({
        features: data,
      }),
    });

    let initialMap;
    initialMap = new OlMap({
      target: mapElement.current,
      layers: layers(vectors),
      view,
      controls: [],
    });
    setMap(initialMap);
    setVectorLayer(vectors);

    // Conditionally add watermark if view.values_.showWatermark is true
    if (view.values_.showWatermark) {
      initialMap.on("postrender", (event) => {
        const canvas = event.target.getViewport().querySelector("canvas");

        if (canvas) {
          const ctx = canvas.getContext("2d");
          ctx.font = "14px Arial";
          ctx.fillStyle = "rgba(0, 0, 0, 0.7)";
          ctx.textAlign = "right";
          ctx.textBaseline = "bottom";

          const text = view.values_.waterMark;
          ctx.fillText(text, canvas.width - 10, canvas.height - 20);
        }
      });
    }

    initialMap.on("click", featureClicked);
  }, []);

  useEffect(() => {
    if (vectorLayer !== undefined) {
      layersStyle(data);
      vectorLayer.setSource(
        new VectorSource({
          features: data,
        })
      );
    }
  }, [data]);

  //Calls onClick in App.js. Sends data with useRef.current, otherwise data will be null.
  //If there is any features where the user has clicked, take the first one(the feature that is on top) and send that feature.
  const featureClicked = (e) => {
    let features = [];

    mapRef.current.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
      features.push(feature);
    });
    const [firstFeature] = features.slice(0);
    if (firstFeature) props.onClick(firstFeature, dataRef.current);
  };

  return <div style={{ height: "100%" }} ref={mapElement} />;
}
